module.exports = __webpack_public_path__ + "static/img/cbsj.044a226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/cbsj.png
// module id = E/NJ
// module chunks = 1